import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import styles from './imageViewer.scss';

@CSSModules(styles, {allowMultiple: true})
export default class ImageViewer extends React.Component {

  static propTypes = {
    content: PropTypes.array.isRequired,
    fileFormat: PropTypes.string.isRequired
  };

  render() {
    const {content, fileFormat} = this.props;
    if (!content || !fileFormat) {
      return null;
    }
    const statementPagesContents = content.map((imageBase64) =>`data:image/${fileFormat};base64,${imageBase64}`);
    return (
      <div styleName="imageViewer">
        {statementPagesContents.map((statementPageContent,index) =>
          <div styleName="imageContainer" key={index}>
              <img
              src={statementPageContent}
              alt="Statement Image"/>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pdf/ImageViewer.js